// relationshipCorrection.js
import { API_BASE } from '../../api/config';

const REL_CORRECTION_PATTERNS = [
  /my (\w+)'s name is not (\w+)/i,
  /my (\w+) name is not (\w+)/i,
  /(\w+) is not my (\w+)/i,
  /(\w+) isn't my (\w+)/i,
  /(\w+) isn’t my (\w+)/i
];

export function detectCorrection(message = '') {
  const normalized = message.replace(/[’']/g, "'").toLowerCase().trim();

  for (const pattern of REL_CORRECTION_PATTERNS) {
    const match = normalized.match(pattern);
    if (match) {
      let role, name;

      if (pattern === REL_CORRECTION_PATTERNS[0] || pattern === REL_CORRECTION_PATTERNS[1]) {
        role = match[1];
        name = match[2];
      } else {
        name = match[1];
        role = match[2];
      }

      return {
        match: true,
        target: {
          type: 'relationship',
          name: capitalize(name),
          role: normalizeRole(role)
        }
      };
    }
  }

  return { match: false };
}


export async function applyCorrection(target, shadowId) {
  console.log('🧹 Applying correction for:', target);

  try {
    const url = `${API_BASE}/api/context/correct`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...target, shadowId })  // ←using shadowId 
    });

    const data = await res.json();

if (res.ok && data.success) {
  console.log('✅ Relationship correction succeeded:', data);
  return {
    success: true,
    name: target.name,
    role: target.role,
    message: `Okay, I’ve removed ${target.name} as your ${target.role}.`
  };
}
 else {
      console.error('❌ Correction failed:', data);
return {
  success: false,
  name: target.name,
  role: target.role,
  message: `Hmm, I wasn’t able to remove ${target.name} as your ${target.role}. I’ve let my development team know...`
};

    }
  } catch (err) {
    console.error('❌ Correction request error:', err);
return {
  success: false,
  name: target.name,
  role: target.role,
  message: `Hmm, I wasn’t able to remove ${target.name} as your ${target.role}. I’ve let my development team know...`
};

  }
}



// Helpers
function normalizeRole(role) {
  const map = {
    mom: 'mother',
    mother: 'mother',
    dad: 'father',
    father: 'father',
    sis: 'sister',
    sister: 'sister',
    bro: 'brother',
    brother: 'brother',
    son: 'son',
    daughter: 'daughter',
    child: 'child',
    wife: 'wife',
    husband: 'husband',
    girlfriend: 'girlfriend',
    boyfriend: 'boyfriend',
    'ex-girlfriend': 'ex-girlfriend',
    'ex-boyfriend': 'ex-boyfriend',
    'ex wife': 'ex-wife',
    'ex-husband': 'ex-husband',
    exwife: 'ex-wife',
    exhusband: 'ex-husband',
    grandma: 'grandmother',
    grandmother: 'grandmother',
    grandpa: 'grandfather',
    grandfather: 'grandfather',
    aunt: 'aunt',
    aunts: 'aunt',
    uncle: 'uncle',
    uncles: 'uncle',
    cousin: 'cousin',
    cousins: 'cousin',
    friend: 'friend',
    buddy: 'friend',
    pal: 'friend'
  };
  return map[role.toLowerCase()] || role.toLowerCase();
}

function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
